export const GET_CONTENT = 'GET_CONTENT';

export const ROUTE_CHANGE = 'ROUTE_CHANGE';

export const IS_PRELOADING = 'IS_PRELOADING';

export const HAS_PRELOADED = 'HAS_PRELOADED';

export const HAS_PRELOADED_HALF = 'HAS_PRELOADED_HALF';

export const LOGO_ANIMATED = 'LOGO_ANIMATED';

export const TOGGLE_CLASS = 'TOGGLE_CLASS';

export const SHOW_NAV = 'SHOW_NAV';

export const HIDE_NAV = 'HIDE_NAV';

export const NOT_TOUCH_DEVICE = 'NOT_TOUCH_DEVICE';



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/store/types.js